import { client } from "../../client";
import { showJudgeControls, currentPosIsJudge } from "../../dom/judgeControls";

/**
 * Set the judge-control state from the server (JD packet).
 * @param args JD#<state># where state is the AO2 JudgeState
 *   (-1 position-dependent, 0 force-hidden, 1 force-shown e.g. while CM).
 */
export const handleJD = (args: string[]) => {
  client.judgeState = Number(args[1]);
  showJudgeControls(currentPosIsJudge());
};
